import React, { useState, useEffect } from "react";
import { View, TouchableOpacity, ScrollView, } from "react-native";
import { Text } from "../../../Text/Text";
import { Icon } from "../../../Icon/Icon";
import { styles } from "./InputList.styles";
import { InputText } from "../InputText/InputText";
import { icons } from "@clearabee/ui-library-base";
const ListItem = ({ isSearchable, item, last, first, active, optionsStyles, optionStyles, tick, customIcon, ...rest }) => {
    return (React.createElement(TouchableOpacity, { ...rest, style: [
            styles.item,
            last && styles.lastItem,
            first && isSearchable && styles.topBorder,
            optionsStyles,
        ] },
        React.createElement(View, { style: styles.row },
            typeof item.label === "string" && (React.createElement(Text, { styles: [styles.optionText, optionStyles] }, item.label)),
            typeof item.label !== "string" && item.label,
            active && customIcon,
            active && !customIcon && (React.createElement(View, { style: styles.tick },
                React.createElement(Icon, { ...icons[tick], color: "positive", width: 20, height: 20 }))))));
};
/**
 * If desired, this input select can render just a list of items,
 * OR it can show a search bar, to filter through these items,
 * and if there are many items, the height of the list can
 * be set, and this will render the list within a ScrollView,
 * so you can scroll within the list on the screen.
 */
export const InputList = ({ placeholder, name, height, disabled, isSearchable, options: items, onChange, styles: userStyles, optionsStyles, optionStyles, searchBoxStyles, isLoading, value, tick = "Tick", customIcon, removeBorder, ...rest }) => {
    const [selected, setSelected] = useState(items.find((item) => item.value === value));
    const [listOfItems, setList] = useState(items);
    useEffect(() => {
        setList(items);
    }, [items]);
    useEffect(() => {
        if (onChange && selected) {
            onChange(String(selected.value));
        }
    }, [selected]);
    /**
     * By default, this input select will render all the options
     * passed to it, as a list. If isSearchable is enabled,
     * when you enter a search term,
     * this function will start to filter the list, and return
     * a shortened list of items that match the search term.
     * @param searchTerm - a string search term
     * @returns a filtered list of items.
     */
    const searchList = (searchTerm) => {
        const filteredList = items.filter(({ value }) => {
            return String(value).toUpperCase().includes(searchTerm.toUpperCase());
        });
        setList(filteredList);
    };
    return (React.createElement(View, { ...rest, style: [styles.default, userStyles, isLoading && styles.loading] },
        disabled && (React.createElement(View, { pointerEvents: disabled && "none" },
            React.createElement(InputText, { name: "disabled", disabled: true, placeholder: placeholder, testID: "inputSelectDisabledInput" }))),
        isSearchable && !disabled && (React.createElement(View, { style: styles.searchBarContainer },
            React.createElement(View, { style: styles.searchIconContainer },
                React.createElement(Icon.Search, { color: "greyscale", size: "medium" })),
            React.createElement(InputText, { styles: searchBoxStyles, testID: "inputSelectSearchBar", onChange: (value) => searchList(value), name: `search${name}`, placeholder: placeholder }))),
        !disabled && (React.createElement(ScrollView, { testID: "inputSelectScrollView", style: { height }, nestedScrollEnabled: true }, listOfItems.map((item, index) => {
            return (React.createElement(ListItem, { key: index, item: item, last: index + 1 === items.length || removeBorder, isSearchable: isSearchable, first: index === 0, onPress: () => setSelected(item), active: selected?.value === item.value, optionsStyles: optionsStyles, optionStyles: optionStyles, tick: tick, customIcon: customIcon }));
        })))));
};
//# sourceMappingURL=InputList.js.map